Tooltip = require 'components/common/tooltip'
CustomRenderMixin = require 'components/mixins/custom_render_mixin'
{ string } = PropTypes

ValidationContainer = ({ children, className, errorMsg, tipJoint, targetJoint }) ->

  className = classNames 'validation-container', className, invalid: errorMsg

  if errorMsg
    <Tooltip
      targetJoint={targetJoint}
      tipJoint={tipJoint}
      tooltipType="reactValidationError"
    >
      <div className={className} title={errorMsg}>
        {children}
      </div>
    </Tooltip>
  else
    <div className={className} >
      {children}
    </div>

module.exports = ValidationContainer
